import { Card, CardContent } from "@/components/uiDir/card";
import { Eye, Heart } from "lucide-react";

interface KeyInsightsProps {
  profileViews: number;
  totalLikes: number;
}

export const KeyInsights = ({ profileViews, totalLikes }: KeyInsightsProps) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
      <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-blue-100 rounded-xl">
              <Eye className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-2xl font-bold">{profileViews}</p>
              <p className="text-xs text-gray-500">Profile Views</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-pink-100 rounded-xl">
              <Heart className="h-5 w-5 text-pink-600" />
            </div>
            <div>
              <p className="text-2xl font-bold">{totalLikes}</p>
              <p className="text-xs text-gray-500">Total Reactions</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};